import { Component, OnInit, AfterViewInit, Renderer, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { JhiLanguageService, EventManager } from 'ng-jhipster';

import { LoginService } from '../login/login.service';
import { StateStorageService } from '../auth/state-storage.service';
import { PASSWORD_INPUT_CLASS } from '../constants/password.constants';

@Component({
    selector: 'jhi-login-modal',
    templateUrl: './login.component.html'
})
export class JhiLoginModalComponent implements OnInit, AfterViewInit {
    authenticationError: boolean;
    password: string;
    rememberMe: boolean;
    username: string;
    credentials: any;
    showPassword: boolean;
    passwordInputClass: string;

    constructor(
        private eventManager: EventManager,
        private languageService: JhiLanguageService,
        private loginService: LoginService,
        private stateStorageService: StateStorageService,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private router: Router,
        private http: HttpClient,
        public activeModal: NgbActiveModal
    ) {
        this.credentials = {};
    }

    ngOnInit() {
        this.languageService.addLocation('login');
        this.showPassword = false;
        this.passwordInputClass = PASSWORD_INPUT_CLASS.HIDE;
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []);
    }

    cancel() {
        this.credentials = {
            username: null,
            password: null,
            rememberMe: true
        };
        this.authenticationError = false;
        this.activeModal.dismiss('cancel');
    }

    toggleShowPassword(event: MouseEvent) {
        this.showPassword = !this.showPassword;
        this.passwordInputClass = this.showPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    onKeyDown(event: KeyboardEvent): void {
        // this is to not toggle the show text upon enter key, but do login
         if (event.key === 'Enter') {
          event.preventDefault();
          this.login();
        }
    }

    login() {
        this.loginService.login({
            username: this.username,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(() => {
            this.authenticationError = false;
            this.activeModal.dismiss('login success');
            if (this.router.url === '/register' ||
                (/activate/.test(this.router.url)) ||
                this.router.url === '/finishReset' ||
                this.router.url === '/requestReset') {
                this.router.navigate(['']);
            } else if (this.router.url.includes('reset/finish?key')) {
                this.router.navigate(['']);
            } else if (this.router.url.includes('lesson-public')) {
                this.router.navigate(['']);
            }

            // refactor the previous code to use the postloginRedirectUrl
            // when the user was on the lesson public page and then logged in,
            // the user should be redirected to the lesson detail page to do the registration
            const postLoginRedirectUrl = this.stateStorageService.getPostLoginRedirectUrl();
            if (postLoginRedirectUrl) {
                this.stateStorageService.deletePostLoginRedirectUrl();
                this.router.navigateByUrl(postLoginRedirectUrl);
            }

            this.eventManager.broadcast({
                name: 'authenticationSuccess',
                content: this.username
            });

            // TODO change this when the Student can belong to several Schools, cause the user will do login and probably there
            // will be a button to change he is seeing in a given time
            this.http.get('api/schools/current').subscribe((res: HttpResponse<any>) => {
                let school: any = res;
                if (school) {
                    if (school.timezone) {
                        this.stateStorageService.setCurrentTimezone(school.timezone);
                    }
                    if (school.navbarColor) {
                        this.stateStorageService.setNavbarColor(school.navbarColor);
                    }
                    if (school.footerColor) {
                        this.stateStorageService.setFooterColor(school.footerColor);
                    }
                    if (school.backgroundColor) {
                        this.stateStorageService.setBackgroundColor(school.backgroundColor);
                    }
                }
            }, (error: Response) => {});


            // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
            // // since login is successful, go to stored previousState and clear previousState
            let previousState = this.stateStorageService.getPreviousState();
            if (previousState) {
                this.stateStorageService.resetPreviousState();
                this.router.navigate([previousState.name], { queryParams: previousState.params });
            }
        }).catch(() => {
            this.authenticationError = true;
        });
    }

    register() {
        this.activeModal.dismiss('to state register');
        this.router.navigate(['/register']);
    }

    requestResetPassword() {
        this.activeModal.dismiss('to state requestReset');
        this.router.navigate(['/reset', 'request']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/login/login.component.ts